import TenantsPageContent from "../components/MyTenant/TenantsPageContent"

type Props = {
  publicBucketName: string
  heroImage: string
  tenantId?: number
}

const TenantsPage = ({ publicBucketName, heroImage, tenantId }: Props) => {
  return <TenantsPageContent publicBucketName={publicBucketName} heroImage={heroImage} tenantId={tenantId} />
}

export default TenantsPage